<template>
  <div>
    <transition name="slide-fade">
      <div
        v-if="showModal"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div
          v-on-click-outside="closeModal"
          class="relative mr-0 mx-auto w-3xl h-full w-full"
          :class="{
            'lg:w-[1200px]': size == 'xl',
            'lg:w-[350px]': size == 'sm',
            'lg:w-[800px]': !size,
          }"
        >
          <!--content-->
          <div
            class="border-0 shadow-lg relative flex flex-col w-full bg-white dark:bg-blueDianne dark:text-white outline-none focus:outline-none h-full"
          >
            <!--header-->
            <div
              v-if="!hideHeader"
              class="flex items-center justify-between py-3 px-5 border-b border-solid border-tiara-100 rounded-t bg-white z-2"
            >
              <slot name="header"> </slot>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                @click="toggleModal()"
              >
                <span
                  class="bg-transparent text-black dark:text-white w-6 text-xl block outline-none focus:outline-none"
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              </button>
            </div>
            <!--body-->
            <div ref="modalBody" class="relative flex-auto overflow-y-auto z-0">
              <button
                v-if="hideHeader"
                class="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute z-2 right-4 mt-2"
                @click="toggleModal()"
              >
                <span
                  class="bg-transparent text-black dark:text-white w-6 text-xl block outline-none focus:outline-none"
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              </button>
              <slot name="body"> </slot>
            </div>
            <!--footer-->
            <div
              v-if="!hideFooter"
              class="flex items-center justify-end px-6 py-3 border-t border-solid border-tiara-100 rounded-b"
            >
              <slot name="footer"> </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="showModal"
        class="opacity-25 fixed inset-0 z-40 bg-black"
      ></div>
    </transition>
  </div>
</template>

<script>
import { vOnClickOutside } from "@vueuse/components";
import { utils } from "common-frontend";

const { scrollIntoViewWithOffset } = utils;

export default {
  name: "RightSideModal",
  directives: {
    onClickOutside: vOnClickOutside,
  },
  props: {
    showing: Boolean,
    hideFooter: Boolean,
    hideHeader: Boolean,
    size: String,
  },
  data() {
    return {
      showModal: this.showing,
    };
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
      this.$emit("toggled", this.showModal);
    },
    openModal() {
      if (!this.showModal) {
        this.toggleModal();
      }
    },
    closeModal() {
      if (this.showModal) {
        this.toggleModal();
      }
    },
    onClickOutside() {
      this.toggleModal();
    },
    scrollToEl(el, offset) {
      scrollIntoViewWithOffset(el, offset, this.$refs.modalBody);
    },
  },
};
</script>

<style lang="scss">
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.5s ease-in;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.3s ease-out;
}

.fade-leave-active {
  transition: all 0.3s ease-in;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
